// src/ThemeContext.js
import React, { createContext, useMemo, useState } from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export default function CustomThemeProvider({ children }) {
  const [mode, setMode] = useState('light');
  const colorMode = useMemo(() => ({
    toggleColorMode: () => setMode(prev => (prev === 'light' ? 'dark' : 'light')),
  }), []);

  const theme = useMemo(
    () => createTheme({
      palette: {
        mode,
        primary: {
          main: '#e6401f',
          dark: '#b72d12',
          light: '#f26a3d',
          contrastText: '#ffffff',
        },
        secondary: {
          main: '#1565c0',
          dark: '#0d47a1',
          light: '#5e92f3',
          contrastText: '#ffffff',
        },
        background: {
          default: mode === 'light' ? '#faf8f6' : '#1f1714',
          paper: mode === 'light' ? '#ffffff' : '#2a201c',
        },
      },
      shape: {
        borderRadius: 8,
      },
    }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        {/* Normalize styles for both modes */}
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
